import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, ShieldAlert } from 'lucide-react';

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4"
         style={{ background: 'var(--surface-1)' }}>
      <div className="text-center max-w-md w-full">

        {/* 403 Icon / number */}
        <div className="relative mb-6 select-none flex justify-center">
          <div className="w-32 h-32 rounded-full flex items-center justify-center" style={{ background: '#fee2e2' }}>
             <ShieldAlert size={64} className="text-red-500" />
          </div>
        </div>

        {/* Message */}
        <h1 className="font-display font-black text-2xl mb-2" style={{ color: 'var(--text-1)' }}>
          Không có quyền truy cập
        </h1>
        <p className="text-sm mb-8 leading-relaxed" style={{ color: 'var(--text-3)' }}>
          Bạn không có quyền truy cập vào trang này hoặc tính năng này.
          <br />Vui lòng liên hệ quản trị viên hoặc quay về trang chủ.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border text-sm font-medium transition-all hover:border-orange-400 hover:text-orange-500"
            style={{ borderColor: 'var(--border-c)', color: 'var(--text-2)' }}
          >
            <ArrowLeft size={15} /> Quay lại
          </button>

          <Link to="/"
            className="btn-brand flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold">
            <Home size={15} /> Trang chủ
          </Link>
        </div>

        {/* FNB HUB brand */}
        <p className="mt-10 text-xs" style={{ color: 'var(--text-3)' }}>
          © 2025 <span style={{ color: 'var(--brand)' }} className="font-semibold">FNB HUB</span> — Nền tảng F&B hàng đầu Việt Nam
        </p>
      </div>
    </div>
  );
}
